import Big from 'big.js'
import { Measure } from '../types'

enum RadioactivityEqDoseMeasurementSystem {
  siUnits = 'SI Units',
  traditionalUnits = 'Traditional Units',
  contextSpecificUnits = 'Context-Specific Units'
}


const radioactiveEquivalentDoseUnits = {
  microsievert: {
    displayName: 'Microsievert',
    codeName: 'microsievert',
    url: 'microsievert',
    symbol: 'µSv',
    toBaseUnit: (value: Big): Big => value.times(0.000001),
    fromBaseUnit: (value: Big): Big => value.div(0.000001),
    system: RadioactivityEqDoseMeasurementSystem.siUnits
  },
  millisievert: {
    displayName: 'Millisievert',
    codeName: 'millisievert',
    url: 'millisievert',
    symbol: 'mSv',
    toBaseUnit: (value: Big): Big => value.times(0.001),
    fromBaseUnit: (value: Big): Big => value.div(0.001),
    system: RadioactivityEqDoseMeasurementSystem.siUnits
  },
  sievert: {
    displayName: 'Sievert',
    codeName: 'sievert',
    url: 'sievert',
    symbol: 'Sv',
    toBaseUnit: (value: Big): Big => value,
    fromBaseUnit: (value: Big): Big => value,
    system: RadioactivityEqDoseMeasurementSystem.siUnits
  },


  microrem: {
    displayName: 'Microrem',
    codeName: 'microrem',
    url: 'microrem',
    symbol: 'µrem',
    toBaseUnit: (value: Big): Big => value.times(0.00000001),
    fromBaseUnit: (value: Big): Big => value.div(0.00000001),
    system: RadioactivityEqDoseMeasurementSystem.traditionalUnits
  },
  millirem: {
    displayName: 'Millirem',
    codeName: 'millirem',
    url: 'millirem',
    symbol: 'mrem',
    toBaseUnit: (value: Big): Big => value.times(0.00001),
    fromBaseUnit: (value: Big): Big => value.div(0.00001),
    system: RadioactivityEqDoseMeasurementSystem.traditionalUnits
  },
  rem: {
    displayName: 'Rem (Röntgen Equivalent Man)',
    codeName: 'rem',
    url: 'rem',
    symbol: 'rem',
    toBaseUnit: (value: Big): Big => value.times(0.01),
    fromBaseUnit: (value: Big): Big => value.div(0.01),
    system: RadioactivityEqDoseMeasurementSystem.traditionalUnits
  },


  dental_radiography: {
    displayName: 'Dental Radiography',
    codeName: 'dental_radiography',
    url: 'dental-radiography',
    symbol: 'dental rad',
    toBaseUnit: (value: Big): Big => value.times(0.000005),
    fromBaseUnit: (value: Big): Big => value.div(0.000005),
    system: RadioactivityEqDoseMeasurementSystem.contextSpecificUnits
  },
  average_individual_background_radiation_dose_per_hour: {
    displayName: 'Average Individual Background Radiation Dose per Hour',
    codeName: 'average_individual_background_radiation_dose_per_hour',
    url: 'average-individual-background-radiation-dose-per-hour',
    symbol: 'Bq/hr',
    toBaseUnit: (value: Big): Big => value.div(4347826.1),
    fromBaseUnit: (value: Big): Big => value.times(4347826.1),
    system: RadioactivityEqDoseMeasurementSystem.contextSpecificUnits
  },
  vicinity_of_the_reactor_core_after_the_chernobyl_disaster_per_hour: {
    displayName: 'Vicinity to Chernobyl / per hour',
    codeName: 'vicinity_of_the_reactor_core_after_the_chernobyl_disaster_per_hour',
    url: 'chernobyl-vicinity',
    symbol: '',
    toBaseUnit: (value: Big): Big => value.div(0.00333333333333333),
    fromBaseUnit: (value: Big): Big => value.times(0.00333333333333333),
    system: RadioactivityEqDoseMeasurementSystem.contextSpecificUnits
  }
}

export const radioactiveEquivalentDose: Measure = {
  displayName: 'Radioactivity (eq. dose)',
  codeName: 'radioactiveEquivalentDose',
  url: 'radioactive-eq-dose',
  units: radioactiveEquivalentDoseUnits,
  baseUnit: radioactiveEquivalentDoseUnits.sievert,
  defaultFromUnit: radioactiveEquivalentDoseUnits.sievert,
  defaultToUnit: radioactiveEquivalentDoseUnits.microsievert
}
